export default __webpack_public_path__ + "static/media/An.1e07a350.svg";